// src/components/DrinksStockViewer.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  onSnapshot,
  doc,
  updateDoc,
  increment,
  getDoc,
  setDoc,
} from 'firebase/firestore';

export default function DrinksStockViewer() {
  const [drinks, setDrinks] = useState([]);
  const [deltas, setDeltas] = useState({});
  const [lastCsvDate, setLastCsvDate] = useState('');  // ISO YYYY-MM-DD
  const [newCsvDate, setNewCsvDate]   = useState('');

  // "YYYY-MM-DD" -> "DD/MM/YYYY"
  const prettyDate = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('-');
    return `${d}/${m}/${y}`;
  };

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'stock_shop_drinks'), snap => {
      const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      rows.sort((a, b) => displayName(a).localeCompare(displayName(b)));
      setDrinks(rows);
    });
    return () => unsub();
  }, []);

  // load saved cutoff date
  useEffect(() => {
    (async () => {
      const ref = doc(db, 'meta', 'last_drinks_csv');
      const snap = await getDoc(ref);
      if (snap.exists()) setLastCsvDate(snap.data().date || '');
    })();
  }, []);

  const displayName = (d) => d.name?.trim() || d.id.replace(/_/g, ' ');

  const applyChange = async (drink) => {
    const raw = deltas[drink.id];
    if (raw === '' || raw === undefined) return;
    const delta = Number(raw);
    if (Number.isNaN(delta) || delta === 0) return;

    await updateDoc(doc(db, 'stock_shop_drinks', drink.id), {
      units: increment(delta),
    });
    setDeltas(prev => ({ ...prev, [drink.id]: '' }));
  };

  const saveCsvDate = async () => {
    if (!newCsvDate) return;
    await setDoc(doc(db, 'meta', 'last_drinks_csv'), { date: newCsvDate });
    setLastCsvDate(newCsvDate);
    setNewCsvDate('');
  };

  return (
    <div className="drinks-stock">
      <h2>🥤 Drinks Stock</h2>

      {/* CSV cutoff box */}
      <div style={{ background: '#f1f1f1', padding: 12, marginBottom: 20, borderRadius: 8 }}>
        <strong>Last POS CSV covers up to:</strong>{' '}
        {lastCsvDate ? prettyDate(lastCsvDate) : '— not set —'}
        <div style={{ marginTop: 8 }}>
          <input
            type="date"
            value={newCsvDate}
            onChange={e => setNewCsvDate(e.target.value)}
          />
          <button className="btn btn-primary" style={{ marginLeft: 8 }} onClick={saveCsvDate}>
            Save Date
          </button>
        </div>
        <p style={{ fontSize: '0.85em', marginTop: 6 }}>
          Use this to remember the last date covered by your uploaded POS CSV.
          Next upload should start from the following day.
        </p>
      </div>

      <table className="table table--stack drinks-stock-table" border="1" cellPadding="8" style={{ textAlign: 'center', width: '100%' }}>
        <thead>
          <tr>
            <th>Drink</th>
            <th>Current Units</th>
            <th>Add / Remove</th>
          </tr>
        </thead>
        <tbody>
          {drinks.map(d => (
            <tr key={d.id}>
              <td>{displayName(d)}</td>
              <td>{d.units ?? 0}</td>
              <td>
                <input
                  type="number"
                  style={{ width: 80, marginRight: 6 }}
                  value={deltas[d.id] ?? ''}
                  onChange={(e) => setDeltas(prev => ({ ...prev, [d.id]: e.target.value }))}
                  placeholder="+/-"
                />
                <button className="btn btn-primary" onClick={() => applyChange(d)}>
                  Update
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <p style={{ fontSize: '0.9em', color: '#555', marginTop: 8 }}>
        Enter a positive number to add bottles or a negative number to subtract.
      </p>
    </div>
  );
}
